export class Mediator {
  parentReferences = {};

  constructor (parentReferences) {
    this.parentReferences = parentReferences
  }

  componentMethod (componentName, method) {
    let component = this.parentReferences[componentName] ?? {}
    let callable = () => {
    }
    if (component[method] instanceof Function) {
      callable = component[method]
    }

    return callable
  }

  setButtons (buttons) {
    let setButtonMethod = this.componentMethod('sign-widget-buttons', 'setButtons')
    setButtonMethod(buttons);
  }

  resetButtons () {
    let setButtonMethod = this.componentMethod('sign-widget-buttons', 'setButtons')
    setButtonMethod([]);
  }
}
